// src/components/widgets/symbols.ts
export const EQUITIES = [
  { symbol: "AAPL", label: "Apple (AAPL)" },
  { symbol: "MSFT", label: "Microsoft (MSFT)" },
  { symbol: "TSLA", label: "Tesla (TSLA)" },
  { symbol: "SPY",  label: "S&P 500 (SPY)" },
  { symbol: "VTI",  label: "Vanguard Total (VTI)" },
  { symbol: "QQQ",  label: "NASDAQ 100 (QQQ)" },
] as const;
